export enum CycleApprovalState {
    GENERATED = 'GENERATED',
	APPROVED = 'APPROVED',
	REJECTED = 'REJECTED',
	MANUAL_APPROVAL_REQUIRED = 'MANUAL_APPROVAL_REQUIRED'
}

export default CycleApprovalState;
